module.exports = __webpack_public_path__ + "img/20624173904.2c69b7c8.png";